import { User } from 'app/classes/user';
import { Group } from '../models/group.model';

export class GetGroups {
  static readonly type = '[Group Management] GetGroups';
}

export class GetGroupsFailed {
  static readonly type = '[Group Management] GetGroupsFailed';
  constructor(public reason: any) { }
}

export class GetUsers {
  static readonly type = '[Group Management] GetUsers';
}

export class GetUsersFailed {
  static readonly type = '[Group Management] GetUsersFailed';
  constructor(public reason: any) { }
}

export class SaveGroup {
  static readonly type = '[Group Management] SaveGroup';
  constructor(public group: Group) { }
}

export class SaveGroupFailed {
  static readonly type = '[Group Management] SaveGroupFailed';
  constructor(public reason: any) { }
}

export class CreateGroup {
  static readonly type = '[Group Management] CreateGroup';
  constructor(public group: Group) { }
}

export class CreateGroupFailed {
  static readonly type = '[Group Management] CreateGroupFailed';
  constructor(public reason: any) { }
}

export class SelectGroup {
  static readonly type = '[Group Management] SelectGroup';
  constructor(public group: Group) { }
}

export class AddMembers {
  static readonly type = '[Group Management] AddMembers';
  constructor(public group: Group, public emails: string[]) { }
}

export class AddMembersFailed {
  static readonly type = '[Group Management] AddMembersFailed';
  constructor(public reason: any) { }
}

export class AddOwners {
  static readonly type = '[Group Management] AddOwners';
  constructor(public group: Group, public users: User[]) { }
}

export class AddOwnersFailed {
  static readonly type = '[Group Management] AddOwnersFailed';
  constructor(public reason: any) { }
}

export class RemoveMember {
  static readonly type = '[Group Management] RemoveMember';
  constructor(public group: Group, public user: User) { }
}

export class RemoveMemberFailed {
  static readonly type = '[Group Management] RemoveMemberFailed';
  constructor(public reason: any) { }
}

export class RemoveOwner {
  static readonly type = '[Group Management] RemoveOwner';
  constructor(public group: Group, public user: User) { }
}

export class RemoveOwnerFailed {
  static readonly type = '[Group Management] RemoveOwner';
  constructor(public reason: any) { }
}

export class EditGroup {
  static readonly type = '[Group Management] EditGroup';
  constructor(public editing: boolean) { }
}

export class ResetGroupManagementState {
  static readonly type = '[Group Management] ResetGroupManagementState';
  constructor() { }
}
